import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "groups-list" }
const _hoisted_2 = { class: "groups-list__groups" }
const _hoisted_3 = { class: "groups-list__groups-item-name" }

import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

type ModalProps = {
  groups: any[];
  disabled: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FilePermitionsUserGroupList',
  props: {
    groups: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const remove = (item: any) => {
  emit("remove", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "groups-list__title" }, "Назначить права для пользователей", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.Id,
          class: "groups-list__groups-item"
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.Name), 1),
          (!_ctx.disabled)
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 0,
                class: "groups-list__groups-item-close",
                name: "close-bold",
                width: "12px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer",
                onClick: ($event: any) => (remove(item))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})